import { atom } from 'recoil'

export const workflowEmailStatsState = atom({
  key: 'WorkflowEmailStatsState',
  default: {
    show: false,
    msgCount: 0,
    idMessage: 0,
    hasStats: false,
    sent: undefined,
    opens: undefined,
    clicks: undefined,
    pctOpens: undefined,
    pctClicks: undefined
  }
})

export const workflowSmsStatsState = atom({
  key: 'WorkflowSmsStatsState',
  default: {
    show: false,
    ids: [],
    sent: undefined,
    delivs: undefined,
    clicks: undefined,
    pctDelivs: undefined,
    pctClicks: undefined
  }
})
